import { AiInsight } from '../data-visualization';
import {
  ResolveBreakdownRow,
  ResolveCampaignRow,
  ResolveMomentRow,
  ResolveOutcomeRow,
} from './resolve.data';

export const previewReceiptViews = '12,480';
export const previewReceiptTrend = 8.4;
export const previewReceiptSubtitle = 'of 18,620 lookups received';
export const previewReceiptMatched = 67;
export const previewReceiptMatchedValue = '8,362';
export const previewReceiptUnmatched = 33;
export const previewReceiptUnmatchedValue = '4,118';

export const previewExternalLinkClicks = [2140, 1265, 548];
export const previewExternalLinkTotal = '3,953';
export const previewExternalLinkShare = '31.7% of views';
export const previewExternalLinkValues = ['2,140', '1,265', '548'];
export const previewExternalLinkPercentages = ['54.1%', '32.0%', '13.9%'];

export const previewTopMoments: ResolveMomentRow[] = [
  { name: 'Order Shipped', quantity: '4,218', share: '33.8%' },
  { name: 'Out for Delivery', quantity: '3,106', share: '24.9%' },
  { name: 'Delivered', quantity: '2,544', share: '20.4%' },
  { name: 'Order Confirmed', quantity: '1,587', share: '12.7%' },
];

export const previewViewOrderStats = {
  sessions: '2,140',
  impressions: '8,362',
  clicks: '2,140',
  ctr: '25.6%',
};

export const previewSourceBreakdown: ResolveBreakdownRow[] = [
  { name: 'Daily Greens Capsules', quantity: '684', cvr: '9.4%', clickRate: '17.2%' },
  { name: 'Collagen Renew Powder', quantity: '512', cvr: '7.8%', clickRate: '14.6%' },
  { name: 'Sleep Support Gummies', quantity: '398', cvr: '6.1%', clickRate: '12.9%' },
  { name: 'Omega-3 Softgels', quantity: '327', cvr: '5.5%', clickRate: '11.4%' },
  { name: 'Hydration Sticks', quantity: '219', cvr: '4.2%', clickRate: '9.8%' },
];

export const previewTopIntents: ResolveBreakdownRow[] = [
  { name: 'Track My Order', quantity: '902', cvr: '11.2%', clickRate: '21.4%' },
  { name: 'Where Is My Refund', quantity: '476', cvr: '8.7%', clickRate: '15.1%' },
  { name: 'Change Delivery Date', quantity: '358', cvr: '6.9%', clickRate: '12.6%' },
  { name: 'Cancel Order', quantity: '241', cvr: '5.3%', clickRate: '10.2%' },
  { name: 'Update Address', quantity: '163', cvr: '4.8%', clickRate: '8.5%' },
];

export const previewBuyAgainStats = {
  visitors: '1,265',
  sales: '184',
  revenue: '$11,408',
  conversionRate: '14.5%',
  aov: '$62.00',
};

export const previewCampaignsOriginated: ResolveCampaignRow[] = [
  { name: 'Daily Greens - Subscribe & Save', quantity: '72', revenue: '$4,536' },
  { name: 'Collagen Renew - Spring Offer', quantity: '51', revenue: '$3,162' },
  { name: 'Sleep Support - Bundle', quantity: '34', revenue: '$2,108' },
  { name: 'Hydration - Starter Pack', quantity: '27', revenue: '$1,602' },
];

export const previewTopProductsPurchased: ResolveCampaignRow[] = [
  { name: 'Daily Greens Capsules', quantity: '68', revenue: '$4,284' },
  { name: 'Collagen Renew Powder', quantity: '47', revenue: '$2,961' },
  { name: 'Sleep Support Gummies', quantity: '35', revenue: '$2,205' },
  { name: 'Omega-3 Softgels', quantity: '21', revenue: '$1,323' },
  { name: 'Hydration Sticks', quantity: '13', revenue: '$819' },
];

export const previewRefundStats = {
  requests: '548',
  billed: '$34,216',
  refunded: '$12,730',
  saved: '$21,486',
  saveRate: '62.8%',
};

export const previewRequestSource: ResolveBreakdownRow[] = [
  { name: 'Northwind Supplements', quantity: '237', share: '43.2%' },
  { name: 'Harbor Wellness Co.', quantity: '154', share: '28.1%' },
  { name: 'Lumen Naturals', quantity: '98', share: '17.9%' },
  { name: 'Cedar & Co.', quantity: '59', share: '10.8%' },
];

export const previewRequestOutcomes: ResolveOutcomeRow[] = [
  { name: 'Deflected to Exchange', quantity: '196', amount: '$0' },
  { name: 'Partial Refund', quantity: '142', amount: '$4,118' },
  { name: 'Full Refund', quantity: '118', amount: '$8,612' },
  { name: 'Pending Review', quantity: '92', amount: '$0' },
];

export const previewAiInsights: AiInsight[] = [
  {
    text: 'Receipt views rose 8.4% this period, driven by Order Shipped moments.',
    icon: '/assets/IconsLibrary/ai-insight-trend-up-icon.svg',
    iconBg: '#E7F8F0',
  },
  {
    text: 'Buy Again converted at 14.5%, generating $11,408 in repurchase revenue.',
    icon: '/assets/IconsLibrary/ai-insight-repurchase-icon.svg',
    iconBg: '#E8F1FF',
  },
  {
    text: '62.8% of refund requests were saved, keeping $21,486 in revenue.',
    icon: '/assets/IconsLibrary/ai-insight-refund-icon.svg',
    iconBg: '#FFF0E3',
  },
  {
    text: 'Track My Order had the highest click rate of any intent, at 21.4%.',
    icon: '/assets/IconsLibrary/ai-insight-shipping-icon.svg',
    iconBg: '#E6F7FB',
  },
];
